import { useQuery } from '@tanstack/react-query';
import Queries from '../Common/Queries';
import { getRegionalAds } from '../Pages/Services/homeService';

export default function useGetAds() {
    return useQuery({
        queryKey: [Queries.GET_REGIONAL_ADS],
        queryFn: () => getRegionalAds(),
        select: (data) => data.data || [],
        meta: { errorMessage: 'Failed to fetch regional ads' },
    });
}
